import { renderMarkdown } from '~/functions/markdown';
export default defineComponent({
  setup: function setup() {},
  methods: {
    renderMarkdown: renderMarkdown
  }
});